import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import { articles } from "@/mocks/articles";
import Hero from "./components/Hero";
import HotTicker from "./components/HotTicker";
import FeaturedSection from "./components/FeaturedSection";
import CategoryGrid from "./components/CategoryGrid";
import HotRanking from "./components/HotRanking";
import PrinciplesSection from "./components/PrinciplesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FaqSection from "./components/FaqSection";
import CtaBand from "./components/CtaBand";

const ORIGIN = "https://bebfdsx.cn";

export default function Home() {
  useSeo({
    title: "黑料在线 - 一键吃瓜速览｜秒开无跳转的娱乐话题站",
    description:
      "黑料在线是一站式娱乐吃瓜速览平台，聚合综艺名场面、影视风向、舞台现场、红毯造型与网络热梗。首页精简直达，快速浏览秒开无跳转，一键吃瓜就能拿到重点结论与浏览路线。",
    keywords: "黑料在线,黑料在线一键吃瓜,黑料在线快速浏览,黑料在线秒开,黑料在线无跳转",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": `${ORIGIN}/#webpage`,
        url: `${ORIGIN}/`,
        name: "黑料在线 - 一键吃瓜速览",
        inLanguage: "zh-CN",
        isPartOf: { "@id": `${ORIGIN}/#website` },
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "黑料在线 今日热门话题",
        itemListElement: articles.slice(0, 6).map((a, i) => ({
          "@type": "ListItem",
          position: i + 1,
          url: `${ORIGIN}/article/${a.id}`,
          name: a.title,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.question,
          acceptedAnswer: { "@type": "Answer", text: f.answer },
        })),
      },
    ],
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <Hero />
        <HotTicker />
        <FeaturedSection />
        <CategoryGrid />
        <HotRanking />
        <PrinciplesSection />
        <TestimonialsSection />
        <FaqSection />
        <CtaBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}